<template>
  <div class="bg-white rounded-lg px-20 py-12 mb-6">
    <div class="flex justify-between items-center h-10">
      <div class="headline-sm text-gray-92">メールアドレス</div>
      <button
        class="block ml-auto bg-white text-coral-main font-semibold border border-coral-main rounded hover:button focus:outline-none"
        style="width: 91px; height: 32px"
        @click="$emit('toggleEmailEditFormShow')"
      >
        編集
      </button>
    </div>
    <div class="body-md border-b border-gray-12 mt-4 pb-3">
      {{ currentEmail }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    currentEmail: {
      type: String,
      require: true,
    },
  },
};
</script>
